import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { Typography } from "@material-tailwind/react";
import { FullScreenLoading } from "components/fullScreenLoading";
import DialogConfirm from "components/wps/DialogConfirm";
import Pagination from "components/wps/Pagination";
import moment from "moment";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "utills/ApiService";
import './dashboard.scss';
import { SwitchButton } from "components/switchButton";
import { isHaveActionPermission } from "utills/helpers";

const Dashboard = (props: any) => {
  const { isMobile, translate, search, filter, setFilter, applyDate, page, setPage, token, permissions } = props;
  const TABLE_HEAD = [translate('no'), translate('role-name'), translate('created-at'), translate('created-by'), translate('updated-at'), translate('status'), translate('action')];

  const [roles, setRoles] = useState([] as any);
  const [paging, setPaging] = useState(null as any);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [activeRole, setActiveRole] = useState({
    is_active: false,
    id: ''
  });
  const [submitAction, setSubmitAction] = useState(false);
  const navigate = useNavigate();
  const [fetchData, setFetchData] = useState(false);

  useEffect(() => {
    if (filter) {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [filter]);

  useEffect(() => {
    if (token !== '' && fetchData) {
      fetchRoles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, token]);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const result = await ApiService.get(`role/page/${page}?q=${search.q}&gte=${applyDate.start}&lte=${applyDate.end}&is_active=${search.status}&limit=10`, token);

      if (result) {
        setPaging(result.paging);
        setRoles(result.roles);
        setFilter(false);
        setFetchData(false);
      }
    } catch (error: any) {
      // toast.error(error.message);
    }

    setLoading(false);
  }

  const handleConfirmAction = async (is_active: boolean, id: string) => {
    setOpen(true);

    is_active ? setDialogMessage(translate('confirm-active-role')) : setDialogMessage(translate('confirm-inactive-role'));
    const activeData = {
      id,
      is_active
    };

    setActiveRole(activeData);
  };

  useEffect(() => {
    if (token !== '' && submitAction) {
      handleActiveRole();
    }
  }, [submitAction, activeRole, translate, roles, token]);

  const handleActiveRole = async () => {
    try {
      const result = await ApiService.put(`role/${activeRole.id}/status`, activeRole, token);

      if (result) {
        setSubmitAction(false);
        const role_temp = [...roles];
        role_temp.forEach((item: any) => {
          if (item.id === activeRole.id) {
            item.is_active = activeRole.is_active;
          }
        });
        setRoles([...role_temp]);
        toast.success(translate('update-success'));
      }
    } catch (error: any) {
      toast.error(error.message);
      setSubmitAction(false);
    }
  }

  if (!isMobile) {
    return (
      <div className={`w-full bg-white rounded-[8px] ${isMobile ? 'p-[16px]' : 'p-[24px]'}`} id="dashboard-list">
        <div className="h-full w-full overflow-x-auto overflow-y-hidden">
          <table className="w-full min-w-max table-auto text-left">
            <thead className="h-[46px] bg-[#f6f5fe]">
              <tr>
                {TABLE_HEAD.map((head, i) => (
                  <th
                    key={head}
                    className="content-table"
                  >
                    <Typography
                      variant="small"
                      className="px-[8px] !text-14 !font-500"
                      placeholder="Typography"
                      onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                      onResizeCapture={() => { }}
                    >
                      {head}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {roles.map((item: any, index: number) => {
                const isLast = index === roles.length - 1;
                const classes = isLast ? "!text-14 h-[46px] px-[8px]" : "border-b border-blue-gray-50 !text-14 h-[46px] px-[8px]";

                return (
                  <tr key={`account_${item.id}_${index}`} className='table-row'>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {
                          index < 9 &&
                          <span>{paging.current_page - 1}{index + 1}</span>
                        }

                        {
                          index === 9 &&
                          <span>{paging.current_page}0</span>
                        }
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {item.name}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {moment(item.created).format('DD/MM/YYYY')}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {item.created_by}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {moment(item.updated).format('DD/MM/YYYY')}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        variant="small"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        <SwitchButton checked={(item.is_active) ? true : false} onChange={() => handleConfirmAction(!item.is_active, item.id)} disabled={(item.name === "Owner" && true) || !isHaveActionPermission("role", "organization","edit", permissions)} />
                      </Typography>
                    </td>
                    <td className={classes}>
                      <div className="flex items-center gap-x-[8px]">
                        <div className="size-[32px] flex items-center justify-center rounded-[4px] bg-[#f5f6f7] cursor-pointer" onClick={() => navigate(`/organization/role/${item.id}`)}>
                          <EyeIcon className="w-4 h-4" />
                        </div>

                        {
                          item.name.toLowerCase() !== 'owner' &&
                          <>
                            {isHaveActionPermission(
                              "role",
                              "organization",
                              "edit",
                              permissions
                            ) && (
                              <div
                                className="size-[32px] flex items-center justify-center rounded-[4px] bg-[#f5f6f7] cursor-pointer"
                                onClick={() =>
                                  navigate(`/organization/role/${item.id}/edit`)
                                }
                              >
                                <PencilIcon className="w-4 h-4" />
                              </div>
                            )}
                          </>
                        }

                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>

          </table>
        </div>

        {
          paging && paging.total_page > 1 &&
          <div className="w-full mt-[-32px] flex justify-between">
            <Pagination
              setPage={setPage}
              paging={paging}
              setFilter={setFilter}
            />
          </div>
        }

        <DialogConfirm
          open={open}
          setOpen={setOpen}
          setSubmitAction={setSubmitAction}
          dialogMessage={dialogMessage}
          isMobile={isMobile}
        />

        {
          loading &&
          <FullScreenLoading />
        }
      </div>
    )
  } else {
    return (
      <div className="w-full grid grid-cols-1 gap-[16px]">
        {
          roles.map((item: any, index: number) => {
            return (
              <div className="w-full rounded-[8px] bg-white p-[16px] grid grid-cols-1 gap-[12px]" key={`account_${item.email}_${index}`}>
                <div className="w-full flex items-center justify-between">

                  <SwitchButton checked={(item.is_active) ? true : false} onChange={() => handleConfirmAction(!item.is_active, item.id)} disabled={(item.name === "Owner" && true) || !isHaveActionPermission("role", "organization","edit", permissions)} />

                  <div className="flex items-center gap-x-[8px]">
                    <Link to={`/organization/role/${item.id}`}>
                      <div className="size-[32px] rounded-[8px] flex items-center justify-center bg-[#f5f6f7]">
                        <EyeIcon className="w-4 h-4" />
                      </div>
                    </Link>

                    {
                      item.name.toLowerCase() !== 'owner' &&
                      <>
                        {isHaveActionPermission("role", "organization", "edit", permissions) && (
                          <Link to={`/organization/role/${item.id}/edit`}>
                            <div className="size-[32px] rounded-[8px] flex items-center justify-center bg-[#f5f6f7]">
                              <PencilIcon className="w-4 h-4" />
                            </div>
                          </Link>
                        )}
                      </>
                    }

                  </div>
                </div>

                <div className="w-full flex items-center gap-x-[8px]">
                  <div className="text-14 font-600">{translate('no')}</div>
                  <div className="flex-1">
                    {
                      index < 9 &&
                      <span>{paging.current_page - 1}{index + 1}</span>
                    }

                    {
                      index === 9 &&
                      <span>{paging.current_page}0</span>
                    }
                  </div>
                </div>

                <div className="w-full flex justify-between gap-x-[8px]">
                  <div className="text-14 font-600">{translate('role-name')}</div>
                  <div className="text-right max-w-[250px] break-words whitespace-normal">{item.name}</div>
                </div>

                <div className="w-full flex justify-between gap-x-[8px]">
                  <div className="text-14 font-600">{translate('created-at')}</div>
                  <div className="text-right max-w-[250px] break-words whitespace-normal">{moment(item.created).format('DD/MM/YYYY')}</div>
                </div>

                <div className="w-full flex justify-between gap-x-[8px]">
                  <div className="text-14 font-600">{translate('created-by')}</div>
                  <div className="text-right max-w-[250px] break-words whitespace-normal">{item.created_by}</div>
                </div>

                <div className="w-full flex justify-between gap-x-[8px]">
                  <div className="text-14 font-600">{translate('updated-at')}</div>
                  <div className="text-right max-w-[250px] break-words whitespace-normal">{moment(item.updated).format('DD/MM/YYYY')}</div>
                </div>
              </div>
            )
          })
        }

        {
          paging && paging.total_page > 1 &&
          <Pagination
            setPage={setPage}
            paging={paging}
            setFilter={setFilter}
          />
        }

        <DialogConfirm
          open={open}
          setOpen={setOpen}
          setSubmitAction={setSubmitAction}
          dialogMessage={dialogMessage}
          isMobile={isMobile}
        />

        {
          loading &&
          <FullScreenLoading />
        }
      </div>
    )
  }

}

export default Dashboard